import { Condition, EntityBase, isArrayWithItems } from '@wix/add-panel-common';
import { always, any, filter, ifElse, pipe, prop, propSatisfies } from 'ramda';
import type { EvaluateCondition } from '../../AddPanel/utils/evaluateCondition';

export const isEntityValidOnConditions = (evaluateCondition: EvaluateCondition) =>
  pipe<EntityBase, Condition[], boolean>(
    prop('conditions'),
    ifElse(isArrayWithItems, any(evaluateCondition), always(true)),
  );

export const filterOutEntitiesByConditions = <T extends EntityBase>(evaluateCondition: EvaluateCondition) =>
  filter<T>(isEntityValidOnConditions(evaluateCondition));

export const filterEntitiesWithChildren = <T>(childrenPropName: string) =>
  filter<T>(propSatisfies(isArrayWithItems, childrenPropName));
